"use client";
import { useEffect } from "react";
import { useOpenDaysFilterContext, OpenDaysSearchFiltersData } from "@packages/lib/utlils/use-context/opendays-filter-context";

/**
 * Client component that pushes searchFilters from server-rendered page data into context.
 * The sidebar (in layout) reads from context — single API call, shared data.
 * Also sets isLoading to false once new data arrives.
 */
const OpenDaysFilterHydrator = ({ searchFilters }: { searchFilters: OpenDaysSearchFiltersData | null }) => {
  const { setSearchFilters, setIsLoading } = useOpenDaysFilterContext();

  useEffect(() => {
    if (searchFilters) {
      setSearchFilters(searchFilters);
    }
    setIsLoading(false);
  }, [searchFilters]);

  return null;
};

export default OpenDaysFilterHydrator;
